/**
 * Calcula o scrollLeft de destino da barra de categorias (nav legado #categoryNav) para
 * trazer a categoria ativa a ~`offset`px da borda esquerda do nav.
 *
 * BUG (com Ionic × sem Ionic): a versão original usava a posição da categoria no VIEWPORT
 * (getBoundingClientRect().left) somada ao scrollLeft, ignorando o offset do próprio nav em
 * relação à esquerda da tela. No desktop (layout centralizado, nav em ~x=551) isso rolava a
 * barra ~450px pra direita já na 1ª categoria, escondendo PROMOÇÃO/COMBOS/PIZZAS — o usuário
 * via "Sushi/Combinados" primeiro. No mobile (nav em x≈0) o offset era ~0 e o bug não aparecia.
 *
 * Fix: usar a posição RELATIVA ao nav (targetLeft - navLeft), independente do viewport.
 */
export function computeCategoryNavScrollLeft(
	currentScrollLeft: number,
	navLeft: number,
	targetLeft: number,
	offset = 100,
): number {
	return currentScrollLeft + (targetLeft - navLeft) - offset;
}
